/**
 * Authentication navigation component.
 * Renders login/logout buttons and navigation links based on authentication state.
 */

import { useOktaAuth } from '@okta/okta-react';
import { Link } from '@tanstack/react-router';
import { AUTH_PATHS, getCurrentOrigin } from '../services';

/**
 * Navigation component that handles authentication UI and user actions.
 */
export function AuthNav() {
  const { oktaAuth, authState } = useOktaAuth();

  /** Initiates login flow with redirect to search page */
  const login = async () =>
    oktaAuth.signInWithRedirect({ originalUri: '/search' });

  /** Initiates logout flow with redirect to logout page */
  const logout = async () =>
    oktaAuth.signOut({
      postLogoutRedirectUri: `${getCurrentOrigin()}${AUTH_PATHS.LOGOUT}`,
    });

  if (!authState) {
    return <p>Loading auth state...</p>;
  }

  return (
    <ul className='flex space-x-4 items-center' aria-label='User actions'>
      <li>
        {/* preload={false} is used to prevent the user from being redirected to authenticate when they hover over the link */}
        <Link
          to='/search'
          className='text-foreground hover:text-primary hover:underline'
          preload={false}
        >
          Search Contracts
        </Link>
      </li>
      {authState.isAuthenticated ? (
        <li>
          <button
            onClick={logout}
            className='text-foreground hover:text-primary hover:underline'
          >
            Logout
          </button>
        </li>
      ) : (
        <li>
          <button
            onClick={login}
            className='text-foreground hover:text-primary hover:underline'
          >
            Login
          </button>
        </li>
      )}
    </ul>
  );
}
